import { gql } from "@apollo/client";
import { INTERVIEW_RESPONSE_ANSWER_FIELDS } from "graphql/fragments";

const HIREFLIX_INVITE_CANDIDATE = gql`
  ${INTERVIEW_RESPONSE_ANSWER_FIELDS}
  mutation addInterviewResponse($input: AddInterviewResponseInput!) {
    addInterviewResponse(input: $input) {
      interviewResponse {
        id
        uuid
        slug
        type
        serviceId
        status
        notes
        answered
        completed
        publicUrl
        thumbnailUrl
        answers {
          ...InterviewResponseAnswerFields
        }
        answersCount
        startedAt
        completedAt
        approvedAt
        profileId
        interviewId
      }
    }
  }
`;

export { HIREFLIX_INVITE_CANDIDATE };
